import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import { BASE_COLOR } from 'shared/constants/colors';
// import { GLOBAL_STYLE } from 'shared/constants/web';

import { composeEditorDraftNew } from 'shared/actions/view/web';
import { compose } from 'shared/helpers';
import { classes as cn } from 'shared/styles';

import { mixClasses as cx } from 'helpers';
import {
  CoreModulePickerRibbon,
  findModuleComposer,
} from 'components/modules';
import { alert } from 'presets';


function mapStateToProps(state) {
  return {
    draftState: state.draft,
    overlayViewState: state.view.get('overlay'),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    composeEditorDraftNew,
  }, dispatch);
};


const ComposerNotFound = (props) => (
  <div className="mw6 center" {...props}>
    {
      alert.error('Oops, something went wrong :(', { closeBtn: null })
    }
  </div>
);


/*
 * ComposeEditor
 */
const dispatchOnSelect = (dispatchFunc) => (
  (e, moduleId) => dispatchFunc({ moduleId })
);

const ComposeEditor = ({
  overlayViewState,
  composeEditorDraftNew,
  ...props
}) => {
  const moduleId = overlayViewState.getIn(['composeEditor', 'displayContext']);
  const draftState = props.draftState.get(moduleId);
  const FoundModuleComposer = findModuleComposer(moduleId) || ComposerNotFound;
  const onSelect = dispatchOnSelect(composeEditorDraftNew);

  return (
    <div className={cx(
      'moa-ff-sans min-h-100',
      cn.animateTranslateUpLarge,
    )}>
      <div className="w-100">
        {moduleId ? (
          <FoundModuleComposer
            moduleId={moduleId}
            draftState={draftState}
          />
        ) : (
          <CoreModulePickerRibbon
            className="mt5"
            onSelect={onSelect}
          />
        )}
      </div>
    </div>
  );
};


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(ComposeEditor);



// WEBPACK FOOTER //
// ./src/components/overlays/ComposeEditor.js